import React from 'react'
import ad from '../assets/aside_ad.png'

const AsideAd = () => {
    return (
        <a href="#a">
            <img src={ad} alt="ad" />
        </a>
    )
}

export default AsideAd